export default __webpack_public_path__ + "static/media/logo-dark.dc3beed3.png";